// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__Ua4S2","title":"InfoRow_title__3gKcQ"};